import { createContext, useContext, type FC, type ReactNode } from 'react'
import { type OverviewPageStore } from 'pages/settings/pages/billing/pages/overview/store/overviewPageStore'

export const OverviewPageContext = createContext<OverviewPageStore | null>(null)

export const useOverviewPageContext = () => {
  const context = useContext(OverviewPageContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with OverviewPageContext')

  return context
}

type IProviderOverviewPageProps = {
  value: OverviewPageStore
  children: ReactNode
}

export const ProviderOverviewPage: FC<IProviderOverviewPageProps> = ({ value, children }) => {
  return <OverviewPageContext.Provider value={value}>{children}</OverviewPageContext.Provider>
}
